module.exports = __webpack_public_path__ + "src/resources/logo.png";